import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getAsyncInjectors } from 'helpers/asyncInjectors';
import Setup, { AccountSetup } from 'modules/Setup';
import { PlainLayout } from 'modules/Layout';
import Account from 'modules/Account';
import { loggedInGuard } from '../guards';
import { getLoader } from '../helpers';
async function action(context) {
    const { route, store, query, getUrl } = context;
    const { enrollCode, invitationCode } = query;
    const Loader = getLoader(store);
    let Component = /*#__PURE__*/ _jsx(Loader, {});
    let redirect;
    if (process.env.BROWSER) {
        redirect = await loggedInGuard(context);
        if (redirect) return {
            name: route.name,
            redirect
        };
        const { injectSagas } = getAsyncInjectors(store);
        injectSagas(Setup.constants.MODULE_ID, Setup.sagas);
        const state = store.getState();
        let searchParams = '';
        const activeProfileType = Account.selectors.activeProfileType(state);
        const activeProfileMainUrlRoute = Account.selectors.activeProfileMainUrlRoute(state);
        const { name, params } = activeProfileMainUrlRoute;
        if (route.name !== name) {
            if (activeProfileType === Account.constants.PROFILE_TYPES.PWD && enrollCode && invitationCode) {
                searchParams = `?enrollCode=${enrollCode}&invitationCode=${invitationCode}`;
            }
            redirect = `${getUrl(name, params)}${searchParams}`;
        }
        if (redirect) return {
            name: route.name,
            redirect
        };
        Component = /*#__PURE__*/ _jsx(PlainLayout, {
            isLocking: true,
            children: /*#__PURE__*/ _jsx(AccountSetup, {
                enrollCode: enrollCode,
                invitationCode: invitationCode
            })
        });
    }
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        redirect,
        component: Component
    };
}
export default action;
